/**
 * User Management Types
 * TypeScript interfaces for user-related data structures
 */

export interface User {
  id: number;
  username: string;
  full_name: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  created_at: string;
  last_login: string | null;
  noise_reduction: NoiseReductionType;
  avatar_enabled: boolean;
  avatar_url?: string | null;
  preferred_language?: string;
  selected_avatar_id?: number | null;
}

export type NoiseReductionType = 'none' | 'near_field' | 'far_field';

export interface UserPreferences {
  noise_reduction: NoiseReductionType;
  avatar_enabled: boolean;
  language_preferences?: string[];
  preferred_language?: string;
  selected_avatar_id?: number | null;
}

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
}

export enum UserStatus {
  ACTIVE = 'active',
  BLOCKED = 'blocked',
  ARCHIVED = 'archived',
}

export interface UserCreateRequest {
  username: string;
  password: string;
  full_name: string;
  email: string;
  role: UserRole;
  tenant_ids?: string[];  // Optional: superadmin can specify tenants
  preferred_language?: string;  // Optional: default 'en'
  app_permissions?: Record<string, boolean>;  // Optional: custom app permissions
}

export interface UserUpdateRequest {
  full_name?: string;
  email?: string;
  role?: UserRole;
  password?: string;
}

export interface AuditLog {
  id: number;
  timestamp: string;
  level: string;
  source: string;
  category: string | null;
  worker_name: string | null;
  event: string | null;
  message: string;
  details: Record<string, unknown> | null;
  error_type: string | null;
  error_trace: string | null;
  duration_ms: number | null;
  session_id: string | null;
  // Enhanced fields
  username: string | null;
  endpoint: string | null;
  ip_address: string | null;
  http_method: string | null;
  http_status: number | null;
  component: string | null;
  user_agent: string | null;
  request_body: string | null;
}

export interface WebSocketEvent {
  id: number;
  timestamp: string;
  event_type: string;
  session_id: string | null;
  username: string | null;
  direction: string | null;
  message_type: string | null;
  message_data: string | Record<string, unknown> | null;
  error_message: string | null;
  error_trace: string | null;
  ip_address: string | null;
}
